// extracted by mini-css-extract-plugin
export var smallSpinner = "_rz-0";